// extracted by mini-css-extract-plugin
export var main = "review-module--main--1yoSi";
export var message = "review-module--message--76H-Z";
export var name = "review-module--name--Omih5";